import styled from 'styled-components';
import { MenuItem } from 'modules/Core/Common';
import { device } from 'modules/Utils/Devices';

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$expanded ? 'space-between' : 'center')};
  height: 80px;
  padding: 0 ${(props) => (props.$expanded ? '16px' : '8px')};
  background-color: ${(props) => props.theme.config.colors.secondary_800};
  border-bottom: 1px solid ${(props) => props.theme.config.colors.secondary_700};
  flex-shrink: 0;

  @media ${device.mobile} {
    display: none;
  }
`;

const LogoWhitelabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`;

const LogoWrapper = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: ${(props) => props.theme.config.colors.primary_600};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const WhitelabelText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media ${device.mobile} {
    flex: 1;
  }
`;

const YouAreIn = styled.span`
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.config.colors.light};
  font-weight: 400;
`;

const WhitelabelName = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.config.colors.primary};
`;

const CollapseButton = styled.button`
  width: ${(props) => (props.$collapsed ? '24px' : '32px')};
  height: ${(props) => (props.$collapsed ? '24px' : '32px')};
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.config.colors.primary_600};
  padding: 0;

  &:hover {
    color: ${(props) => props.theme.config.colors.light};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.config.colors.primary_100};
  padding: 0;

  &:hover {
    color: ${(props) => props.theme.config.colors.light};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const CollapsedHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  width: 100%;
  justify-content: center;
`;

const CollapseIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${(props) =>
    props.$expanded ? 'rotate(0deg)' : 'rotate(180deg)'};
  transition: transform 0.2s ease-in;
`;

const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const AvatarMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .sidebar-header-dropdown {
    top: 48px !important;
    left: 0 !important;

    .rc-dropdown .rc-menu {
      border: 0;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
      min-width: 240px;
    }
  }

  .sidebar-header-dropdown__menu {
    cursor: pointer;
  }
`;

const AvatarWrapper = styled.div`
  width: ${(props) => (props.$collapsed ? '24px' : '32px')};
  height: ${(props) => (props.$collapsed ? '24px' : '32px')};
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
`;

const HamburgerButton = styled.button`
  width: ${(props) => (props.$collapsed ? '24px' : '32px')};
  height: ${(props) => (props.$collapsed ? '24px' : '32px')};
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background-color: ${(props) => props.theme.config.colors.secondary_700};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.config.colors.primary_100};
  padding: 0;

  &:hover {
    color: ${(props) => props.theme.config.colors.light};
    background-color: ${(props) => props.theme.config.colors.secondary_600};
  }
`;

const CollapsedRightActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const SidebarMenuItem = styled(MenuItem)`
  &&& {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1.6rem;
    color: ${(props) => props.theme.config.colors.text_base};
  }

  & + li {
    border-top: 1px solid ${(props) => props.theme.config.colors.gray_100};
  }

  svg {
    width: 16px;
    margin-right: ${(props) => props.theme.config.spacing.spacing_2};

    path {
      fill: ${(props) => props.theme.config.colors.gray_300};
    }
  }

  span {
    ${(props) => props.theme.config.typograph.default};
  }
`;

export {
  Header,
  LogoWhitelabelWrapper,
  LogoWrapper,
  WhitelabelText,
  YouAreIn,
  WhitelabelName,
  CollapseButton,
  CollapsedHeaderContent,
  CollapseIconWrapper,
  CloseButton,
  RightActions,
  AvatarMenuWrapper,
  AvatarWrapper,
  HamburgerButton,
  CollapsedRightActions,
  SidebarMenuItem,
};
